import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";
import { getToken, MunicipalityInTable, Order } from "helpers";

export const municipalityApi = createApi({
  reducerPath: "municipalityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/catalog/municipality/manage`,
    prepareHeaders: (headers) => {
      headers.set("authorization-token", getToken() || "");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getMunicipalities: builder.query<MunicipalityInTable[], ListMunicipalityOptions | void>({
      query: (options) => {
        const { sort = "", order = "" } = options || {};
        return {
          url: "list",
          params: {
            sort,
            order,
          },
        };
      },
      transformResponse: (response: MunicipalityInTable[]) => response,
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
  }),
});

interface ListMunicipalityOptions {
  page?: number;
  pageSize?: number;
  search?: string;
  sort?: string;
  order?: Order;
}

export const {
  useGetMunicipalitiesQuery,
  useLazyGetMunicipalitiesQuery,
  usePrefetch: useMunicipalityApiPrefetch,
} = municipalityApi;
